import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import color from '../../../components/utils/Colors';
// import HeroBanner from '../../../assets/hero-banner.svg';

const Hero: React.FC = () => {
    return (
        <Box
            id="hero"
            sx={{
                width: '100%',
                height: '90vh',
                // backgroundImage: 'linear-gradient(180deg, #e3cefd, #ffffff, #ffffff00)',
                backgroundSize: '100%',
                backgroundRepeat: 'no-repeat',
                pt: { xs: 6, sm: 10 },
                mt:'-110px',
                pb:0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box sx={{background:'#e9d8f7',p:2, boxShadow:2}}>
                <Grid container alignItems="center" >
                    <Grid item xs={12} md={6}>
                        <Stack spacing={2} useFlexGap >
                            {/* <Typography
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    alignSelf: 'start',
                                    textAlign: 'start',
                                    fontSize: '4rem',
                                }}
                            >
                                G2I
                            </Typography> */}
                            <Typography
                                // color="text.secondary"
                                sx={{ alignSelf: 'center',color:color.textColor, textAlign:'center',
                                    fontStyle:'italic',
                                    textShadow: '2px 2px 4px rgba(0, 0, 0, 1)', width: { sm: '100%', md: '80%' }, fontSize: '2.2rem',
                                    WebkitTextStrokeWidth:'1px', WebkitTextStrokeColor:'#BB84E8', fontWeight: 'bolder' }}
                            >
                                Browse Thousands Of Our Video Tutorials Created Only For You.
                            </Typography>
                            <Typography
                                textAlign="center"
                                color="text.secondary"
                                sx={{ alignSelf: 'center',mt:2,color:color.textColor, fontSize:'18px', width: { sm: '100%', md: '80%' } }}
                            >
                                Access all courses when you log in to G2I
                            </Typography>
                            {/* <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                alignSelf="start"
                                spacing={1}
                                useFlexGap
                                sx={{ pt: 5, width: { xs: '100%', sm: 'auto' } }}
                            >
                                <CustomButton
                                    sx={{ bgcolor: '#290854', color: 'white', padding: '12px 30px' }}
                                >
                                    Get Started
                                </CustomButton>
                            </Stack> */}
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src='/assets/hero-banner1.png'
                            alt="Hero Image"
                            sx={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: '500px',
                                margin: '0 auto',
                                mt:2,
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Hero;